import toast from 'react-hot-toast';
import { EyeOff } from 'lucide-react';
import { Button } from '@/components/Button';
import styles from './NeedsAttention.module.css';

/**
 * The toast after a hide: what happened and an Undo that shows the lines
 * again. Copy from the caller (portal namespace), so each portal can say who
 * the line is hidden for.
 */
export function toastNeedsAttentionHidden({
  message,
  undoLabel,
  onUndo,
}: {
  message: string;
  undoLabel: string;
  onUndo: () => void;
}): string {
  return toast(
    (shown) => (
      <span className={styles.toast}>
        <span>{message}</span>
        <Button
          variant="outline"
          size="xs"
          onClick={() => {
            toast.dismiss(shown.id);
            onUndo();
          }}
        >
          {undoLabel}
        </Button>
      </span>
    ),
    { duration: 6000, icon: <EyeOff className={styles.toastIcon} /> }
  );
}
